module.exports = __webpack_public_path__ + "static/pink-square-fd1889b51953a285b00b379ef3b637f7.webp";